import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import ToolbarMui from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import { ReactNode } from 'react';

const Container = styled(ToolbarMui)`
  min-height: 56px;
  background: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.36)}, ${alpha(
          theme.palette.common.white,
          0.06
        )})`
      : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)}, ${alpha(
          theme.palette.secondary.main,
          0.16
        )})`};
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-bottom: 0;
  border-radius: ${({ theme }) => theme.spacing(2.5, 2.5, 0, 0)};
  padding: 0 ${({ theme }) => theme.spacing(2)};

  button {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: ${({ theme }) => alpha(theme.palette.background.paper, 0.72)};

    &:hover {
      background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.1)};
    }
  }

  &.Toolbar-toolbar {
    border: none;
  }

  @media (min-width: 600px) {
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`;

interface TableToolbarProps {
  title: string;
  actions?: ReactNode;
}

const TableToolbar = ({ title, actions }: TableToolbarProps) => (
  <Container variant="dense">
    <Typography variant="subtitle1" color="inherit">
      {title}
    </Typography>
    {actions && <div>{actions}</div>}
  </Container>
);

export default TableToolbar;
